import {
    UPDATE_WIZARD_BIRTHDATE,
    UPDATE_WIZARD_SUB_STEP,
    UPDATE_WIZARD_TOGGLE,
} from '../../mutation-types';

export function updateWizardToggle({ commit }, { key, value }) {
    commit(UPDATE_WIZARD_TOGGLE, { key, value });
}

export function updateWizardBirthdate({ commit }, { value }) {
    commit(UPDATE_WIZARD_BIRTHDATE, { value });
}

export function updateWizardSubStep({ commit }, { value }) {
    commit(UPDATE_WIZARD_SUB_STEP, { value });
}

export function updateRadioTagGroups({ commit }, { key, value, siblingsField }) {
    siblingsField.forEach((fieldName) => commit(UPDATE_WIZARD_TOGGLE, {
        key: fieldName,
        value: false,
    }));
    commit(UPDATE_WIZARD_TOGGLE, { key, value: value });
}
